import { useEffect } from 'react';
import { applyEffectiveTheme } from './apply-theme.js';
import { useEffectiveTheme } from './use-effective-theme.js';

/**
 * FR-07 - jednou vykreslená komponenta v kořeni aplikačního stromu (main.tsx), která drží DOM
 * (`data-theme`, `color-scheme`, `<meta theme-color>`) v souladu s efektivní šablonou a
 * aktualizuje ho při každé změně (předvolba v UserMenu nebo přepínač na landing page, změna
 * systémového nastavení za běhu). Mountuje se v main.tsx aplikace i v kořeni webu apps/landing.
 */
export function ThemeEffect() {
  const effectiveTheme = useEffectiveTheme();

  useEffect(() => {
    applyEffectiveTheme(effectiveTheme);
  }, [effectiveTheme]);

  return null;
}
